import writeExcelFile, { type SheetData } from "write-excel-file/browser";
import {
	buildInvoiceAndReturnsExportFileName,
	invoiceAndReturnsExportHeaders,
	type InvoiceAndReturnsExportParams,
	prepareInvoiceAndReturnsExportData,
	excelHeaderCell,
	excelNumberCell,
	excelTypeCell
} from "./invoiceAndReturnsExportData";

export const exportInvoiceAndReturnsToExcel = async ({
	ledgerEntries,
	startDate,
	endDate
}: InvoiceAndReturnsExportParams) => {
	const { rows, totals } = prepareInvoiceAndReturnsExportData(ledgerEntries);

	const sheetData: SheetData = [
		invoiceAndReturnsExportHeaders.map(excelHeaderCell),
		...rows.map((row) => [
			row.invoiceNumber,
			row.date,
			excelTypeCell(row.type),
			row.customer,
			excelNumberCell(row.amount),
			excelNumberCell(row.cash),
			excelNumberCell(row.upi),
			excelNumberCell(row.outstanding),
			excelNumberCell(row.profit)
		]),
		[
			"Total",
			"",
			"",
			"",
			excelNumberCell(totals.amount, "bold"),
			excelNumberCell(totals.cash, "bold"),
			excelNumberCell(totals.upi, "bold"),
			excelNumberCell(totals.outstanding, "bold"),
			excelNumberCell(totals.profit, "bold")
		]
	];

	await writeExcelFile(sheetData, {
		sheet: "Invoice Returns",
		stickyRowsCount: 1,
		columns: [
			{ width: 18 },
			{ width: 14 },
			{ width: 12 },
			{ width: 28 },
			{ width: 18 },
			{ width: 14 },
			{ width: 14 },
			{ width: 18 },
			{ width: 14 }
		]
	}).toFile(buildInvoiceAndReturnsExportFileName(startDate, endDate, "xlsx"));
};
